<template>
  <div>
    <div class="form-check form-check-inline" style="margin-left: 30px">
      <input class="form-check-input" type="checkbox" id="inlineCheckbox1" v-model="active" @change="changeValue"
             @keyup="changeValue">
      <label class="form-check-label" for="inlineCheckbox1">{{$t('ct-arrow-active')}} </label>
    </div>

    <div v-show="active == true">

      <div class="form-group">
        <label>
          {{$t('ct-arrow-size-width')}}
          <input type="number" :min="min" :max="max" class="custom-input form-control input-border-number"
                 v-model="width"
                 @change="changeValue" @keyup="changeValue">
        </label>
      </div>
      <div class="form-group">
        <label>
          {{$t('ct-arrow-size-width-mobile')}}
          <input type="number" :min="min" :max="max" class="custom-input form-control input-border-number"
                 v-model="widthMobile"
                 @change="changeValue" @keyup="changeValue">
        </label>
      </div>
      <div class="form-group">
        <label>
          {{$t('ct-arrow-size-height')}}
          <input type="number" :min="min" max="500" class="custom-input form-control input-border-number"
                 v-model="height"
                 @change="changeValue" @keyup="changeValue">
        </label>
      </div>
      <div class="form-group">
        <label>
          {{$t('ct-arrow-color')}}
          <color-picker-component ref="colorPicker"></color-picker-component>
        </label>
      </div>
    </div>
  </div>

</template>

<script>

	import ColorPickerComponent from "./Abstract/ColorPicker";

	export default {
		name: 'ArrowConfigComponent',
		components: {ColorPickerComponent},
		data() {
			return {
				element: null,
				active: false,
				width: 33,
				widthMobile: 100,
				height: 50,
				valueColor: '#F0F0F0',
				labelDesc: 'opa',
				callback: null,
				min: 0,
				max: 100,
			}
		},
		methods: {
			changeValue() {

				if (this.width > 100) {
					this.width = 100;
				}
				if (this.width < 0) {
					this.width = 0;
				}
				if (this.widthMobile > 100) {
					this.widthMobile = 100;
				}
				if (this.widthMobile < 0) {
					this.widthMobile = 0;
				}
				if (this.height > 500) {
					this.height = 500;
				}
				if (this.height < 0) {
					this.height = 0;
				}

				this.callback();
			},
			setValues(obj) {

				let vm = this;

				this.active = obj.defaultArrowActive;
				this.width = obj.defaultArrowWidth;
				this.widthMobile = obj.defaultArrowWidthMobile;
				this.height = obj.defaultArrowHeight;
				this.valueColor = obj.defaultArrowColor;

				this.element = obj.element;
				this.labelDesc = this.$t(`ct-${obj.labelDesc}`);
				this.callback = obj.callback;

				let newObj = Object.assign({}, obj);
				newObj.defaultValue = this.valueColor;
				newObj.callback = (value) => {
					vm.valueColor = value;
					vm.changeValue()
				};
				this.$refs.colorPicker.setValues(newObj);
			}
		},
	}

</script>

<style scoped lang="scss">
  .form-group {
    overflow: hidden;
  }

  .place-border-resource {
    display: flex;
  }

  .input-border-number,
  .border-color {
    width: 70px !important;
    min-width: 70px;
  }
</style>





// WEBPACK FOOTER //
// src/components/editor/resources/ArrowConfig.vue